import qs from 'qs';
import { fetchPOST, fetchGET } from 'api/fetchHelper';

const PATH = '/_api/v1/avatar';

const Avatar = {
  create: ({ body, include }) => fetchPOST(`${PATH}?${qs.stringify({ include }, { encodeValuesOnly: true })}`, body),

  get: ({ include, signal }) => fetchGET(`${PATH}?${qs.stringify({ include }, { encodeValuesOnly: true })}`, signal),
};

export default Avatar;
